import React, { useCallback } from 'react';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import ModalEdgeCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalEdgeCloseBtn';
import ModalCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalCloseBtn';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface CollectionOption {
  text: string | number;
  value: string;
}
interface IProps {
  onSubmit?: (data: CollectionOption) => void;
  onClose?: () => void;
  className?: string;
  value: {
    modalTitle?: string;
    isDesktop: boolean;
    isIPhoneXApp: boolean;
    collectionOption: CollectionOption[];
  };
}

const CollectionOptionModal = ({
  onSubmit,
  onClose,
  value,
  className,
}: IProps) => {
  const cName = classNameBind(['collection-option-popup', className || '']);
  const { modalTitle, isDesktop, isIPhoneXApp, collectionOption } = value;

  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  const handleSubmit = useCallback(
    (clickedOption: CollectionOption) => {
      if (typeof onSubmit === 'function') {
        onSubmit(clickedOption);
      }
    },
    [onSubmit]
  );

  return (
    <S.CollectionOptionModal className={cName}>
      {isDesktop ? (
        <>
          {modalTitle && (
            <Text weight={600} size={24} lineHeight="130%">
              {modalTitle}
            </Text>
          )}
          <ModalCloseBtn onClick={handleClose} />
        </>
      ) : (
        <ModalEdgeCloseBtn onClick={handleClose} />
      )}
      <div className="content">
        {collectionOption?.map((v: CollectionOption, i: number) => (
          <Button
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            className="area-click"
            onClick={() => handleSubmit(v)}
          >
            {v.text}
          </Button>
        ))}
      </div>
    </S.CollectionOptionModal>
  );
};

export default CollectionOptionModal;
